module.exports = __webpack_public_path__ + "5dbe60b34752f9f5a2fe5425ab311957.pdf";